import { NgModule } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { EditorComponent } from '../components/editor/editor.component';

const routes: Routes = [
  {
    path: 'mobile-planner',
    component: EditorComponent,
  },
  {
    path: '**',
    component: EditorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
